// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mk-0";